import { css } from "@linaria/core";
import React from "react";
import { fonts, radius } from "@ui";
import { colors } from "@ui/Theme";
import Text from "@ui/Text";

interface CountBarProps {
  fillColor: string;
  textColor: string;
  value: number;
  total: number;
}

const CountBar = ({ fillColor, textColor, value, total }: CountBarProps) => {
  const percentage = Math.min((value / total) * 100, 100);

  if (value === 0) return <Text className={priorityZero}>0</Text>;

  return (
    <div
      className={countBar}
      style={{
        width: `${percentage}%`,
        backgroundColor: fillColor,
        color: textColor,
      }}
    >
      {value}
    </div>
  );
};

export default CountBar;

//#region CSS
const countBar = css`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  min-height: 32px;
  height: 100%;
  font: ${fonts.body1SemiBold};
  border-radius: ${radius};
  transition: width 0.3s ease;
`;
const priorityZero = css`
  color: ${colors.carbon500};
`;
//#endregion CSS
